if (!customElements.get('ls-comparison-table')) {
  customElements.define(
    'ls-comparison-table',
    class LsComparisonTable extends HTMLElement {
      connectedCallback() {
        this.scrollEl = this.querySelector('.lsct__scroll');
        this.tableEl = this.querySelector('.lsct__table');
        this.actions = this.querySelector('.lsct__actions');
        this.toggle = this.querySelector('.lsct__toggle');
        this.label = this.querySelector('.lsct__toggle-label');
        this.collapseRows = parseInt(this.dataset.collapseRows, 10) || 3;

        if (!this.scrollEl || !this.tableEl || !this.toggle) return;

        this.dataRows = Array.from(this.tableEl.querySelectorAll('.lsct__row--body'));

        // Nothing to collapse — leave the full board visible, no button.
        if (this.dataRows.length <= this.collapseRows) return;

        this.classList.add('lsct--enhanced');
        this.isOpen = false;
        this.measure();

        if (this.actions) this.actions.hidden = false;

        this.onToggle = this.onToggle.bind(this);
        this.onResize = this.onResize.bind(this);
        this.toggle.addEventListener('click', this.onToggle);
        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
        window.removeEventListener('resize', this.onResize);
        clearTimeout(this.resizeTimer);
      }

      measure() {
        // Collapsed height = top of the first hidden row + a small peek, so the
        // next row teases through the fade.
        const targetRow = this.dataRows[this.collapseRows];
        if (!targetRow) return;
        const scrollTop = this.scrollEl.getBoundingClientRect().top;
        const rowTop = targetRow.getBoundingClientRect().top;
        const peek = 40;
        const height = Math.round(rowTop - scrollTop + this.scrollEl.scrollTop + peek);
        this.style.setProperty('--lsct-collapsed-height', `${height}px`);
      }

      onResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          if (!this.isOpen) this.measure();
        }, 150);
      }

      onToggle() {
        this.isOpen = !this.isOpen;
        this.classList.toggle('is-open', this.isOpen);
        this.toggle.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');

        if (this.label) {
          const more = this.label.dataset.labelMore;
          const less = this.label.dataset.labelLess;
          this.label.textContent = this.isOpen ? less : more;
        }

        if (!this.isOpen) {
          this.measure();
          this.scrollIntoViewIfNeeded();
        }
      }

      scrollIntoViewIfNeeded() {
        // When collapsing, keep the card in view if its top scrolled off-screen.
        const rect = this.getBoundingClientRect();
        if (rect.top < 0) {
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  );
}
